"use strict";

require("core-js/modules/es6.function.name");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generic SyncLibrary error class
 */

var SyncError =
/*#__PURE__*/
function (_Error) {
  _inherits(SyncError, _Error);

  function SyncError(message) {
    var _this;

    var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, SyncError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SyncError).call(this));
    _this.name = _this.constructor.name;
    _this.message = "".concat(message, " (status: ").concat(status, ", code: ").concat(code, ")");
    _this.status = status;
    _this.code = code;
    return _this;
  }

  return SyncError;
}(_wrapNativeSuper(Error));

exports.SyncError = SyncError;

var SyncNetworkError =
/*#__PURE__*/
function (_SyncError) {
  _inherits(SyncNetworkError, _SyncError);

  function SyncNetworkError(message) {
    var _this2;

    var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var body = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, SyncNetworkError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SyncNetworkError).call(this, message, status, code));
    _this2.body = body;
    return _this2;
  }

  return SyncNetworkError;
}(SyncError);

exports.SyncNetworkError = SyncNetworkError;
exports["default"] = SyncError;